import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from './config/axios'
import { esNativo } from './config/entorno'
import { initNativo } from './native/initNativo'
import 'bootstrap/dist/css/bootstrap.min.css'

// Interceptor para manejar errores de autenticación (usa la instancia configurada)
axios.interceptors.response.use(
  response => response,
  error => {
    if (error.response?.status === 401) {
      store.commit('auth/logout')
      router.push('/login')
    }
    return Promise.reject(error)
  }
)

const app = createApp(App)
app.use(store)
app.use(router)
app.mount('#app')

initNativo(router).catch((err) => {
  console.warn('No se pudo inicializar la capa nativa', err)
})

if (!esNativo() && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js', { scope: '/' }).catch((err) => {
      console.warn('No se pudo registrar el service worker', err);
    });
  });
}
 